import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wolfeboroConfig } from "./data";

export default function WolfeboroPage() {
  return <CityPageTemplate config={wolfeboroConfig} />;
}